export const primariaShellId = "primaria-shell";
